export default __webpack_public_path__ + "static/media/b1.3559c9f0.jpg";